import React from 'react';
import PropTypes from 'prop-types';

function BudgetDoughnutTooltip(props) {
  const { tooltipModel, canvasRef } = props;
  if (!tooltipModel || !canvasRef.current) return null;
  const position = canvasRef.current.getBoundingClientRect();
  const means = tooltipModel.chart.data.datasets[1].data;

  return (
    <div
      className="engage-results-open-budget-tooltip tooltip-wrapper"
      style={{
        opacity: tooltipModel.opacity,
        left: `${position.left + window.scrollX + tooltipModel.caretX}px`,
        top: `${position.top + window.scrollY + tooltipModel.caretY}px`,
      }}
    >
      <div className="engage-results-open-budget-tooltip__title">
        {tooltipModel.title.join(', ')}
      </div>
      <div className="engage-results-open-budget-tooltip__body">
        {tooltipModel.dataPoints.map((dataPoint) => (
          <div
            className="engage-results-open-budget-tooltip__data-points"
            key={dataPoint.datasetIndex}
          >
            <div className="engage-results-open-budget-tooltip__data-point">
              <div>{dataPoint.dataset.label}</div>
              <div>{dataPoint.formattedValue}%</div>
            </div>
            <div className="engage-results-open-budget-tooltip__data-point">
              <div>Mean</div>
              <div>{means[dataPoint.dataIndex]}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

BudgetDoughnutTooltip.propTypes = {
  tooltipModel: PropTypes.shape({
    chart: PropTypes.shape({
      data: PropTypes.shape({
        datasets: PropTypes.arrayOf(
          PropTypes.shape({
            data: PropTypes.arrayOf(PropTypes.number).isRequired,
          }).isRequired
        ).isRequired,
      }).isRequired,
    }).isRequired,
    opacity: PropTypes.number,
    caretX: PropTypes.number,
    caretY: PropTypes.number,
    title: PropTypes.arrayOf(PropTypes.string),
    dataPoints: PropTypes.arrayOf(
      PropTypes.shape({
        datasetIndex: PropTypes.number,
        dataIndex: PropTypes.number,
        dataset: PropTypes.shape({
          label: PropTypes.string,
        }),
        formattedValue: PropTypes.string,
      })
    ),
  }),
  canvasRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};

BudgetDoughnutTooltip.defaultProps = {
  tooltipModel: null,
};

export default BudgetDoughnutTooltip;
